import { Card } from '@mui/material';
import styled from 'styled-components';

export const Form = styled.form`
  margin-top: 8px;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  padding: 20px;
`;

export const GridForm = styled.div`
  display: grid;
  grid-template-columns: auto;
  gap: 30px;
`;
